"use strict";
// @ts-ignore
try {
    self['workbox:recipes:6.6.0'] && _();
}
catch (e) { }
